import { useIdentityStore } from '~/store/identity'

export default defineNuxtRouteMiddleware((to, from) => {
  if (['/bp', '/bp/', '/'].includes(to.path) || to.path === '/login') {
    const nuxtApp = useNuxtApp()
    const { $pinia } = nuxtApp
    return nuxtApp.runWithContext(() => navigateTo({ path: useIdentityStore($pinia).loginUrl, query: to.query }))
  }
});
